import type { Action } from '~/jet/models';

export interface ClearQueueAction extends Action {
    $kind: 'clearQueueAction';
}

export interface PausePlaybackAction extends Action {
    readonly $kind: 'pausePlaybackAction';
}

export interface PlayQueueItemAction extends Action {
    $kind: 'playQueueItemAction';
    itemId: string;
    itemIndex: number;
}

export interface RemoveQueueItemAction extends Action {
    $kind: 'removeQueueItemAction';
    itemId: string;
    itemIndex?: number;
}

export interface ResumePlaybackAction extends Action {
    readonly $kind: 'resumePlaybackAction';
}

export const makeClearQueueAction = (): ClearQueueAction => {
    return {
        $kind: 'clearQueueAction',
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
};

export function makePausePlaybackAction(): PausePlaybackAction {
    return {
        $kind: 'pausePlaybackAction',
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}

export const makePlayQueueItemAction = (
    itemId: string,
    itemIndex: number,
): PlayQueueItemAction => {
    return {
        $kind: 'playQueueItemAction',
        itemId,
        itemIndex,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
};

export const makeRemoveQueueItemAction = (
    itemId: string,
    itemIndex?: number,
): RemoveQueueItemAction => {
    return {
        $kind: 'removeQueueItemAction',
        itemId,
        itemIndex,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
};

export function makeResumePlaybackAction(): ResumePlaybackAction {
    return {
        $kind: 'resumePlaybackAction',
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
